import React from "react";
import "./accesos.css";

export default function Accesos() {
    return (
        <div className="accesos-wrap">
            <div className="acceso-card">
                <h3>Ir a RESULTADOS</h3>
                <p>Consulta los últimos resultados de las competiciones.</p>
                <a href="/resultados" className="btn-acceso">
                    Ver resultados
                </a>
            </div>

            <div className="acceso-card">
                <h3>Ir a CLASIFICACIONES</h3>
                <p>Revisa la clasificación actualizada de cada categoría.</p>
                <a href="/clasificaciones" className="btn-acceso">
                    Ver clasificaciones
                </a>
            </div>
        </div>
    );
}
